import { TPriceWindowApiDto } from 'nexchange-service'
import { createContext, Dispatch } from 'react'

import { IReducerContextProps, ReducerAction } from 'utility-tools/module/reducers'
import { TOverrideType } from 'utility-tools/module/types'

enum CoinsDataReducerAction {
    SET_COINS_STATE = 'SET_COINS_STATE',
}

type TCoinsDataState = {
    tickers: TPriceWindowApiDto[]
}

class SetCoinDataAction extends ReducerAction<TCoinsDataState> {
    constructor(state: TCoinsDataState) {
        super(CoinsDataReducerAction.SET_COINS_STATE, state)
    }
}


const dataParamsInitState: TCoinsDataState = {
   tickers: [],
}


const DataParamsReducer = (
    state: TCoinsDataState = dataParamsInitState,
    action: SetCoinDataAction,
): TCoinsDataState => {
    const { payload = {} } = action as SetCoinDataAction
        return {
            ...state,
            ...(payload as TCoinsDataState),
        }
    }


type TCookieControlContext = TOverrideType<
    IReducerContextProps,
    {
        state: TCoinsDataState
        dispatchAction?: Dispatch<SetCoinDataAction>
    }
>

const coinsDataContext = createContext<TCookieControlContext>({
    state: dataParamsInitState,
})

export { coinsDataContext, dataParamsInitState, SetCoinDataAction }
export default DataParamsReducer
